export function filterDataByUserTags(data) {
  console.log(data);
  let userRole = localStorage.getItem("roles");
  let userTags = JSON.parse(localStorage.getItem("tags"));
  //userRole==="subscriber"&&
  if (userTags !== null && userTags !== undefined) {
    if (userTags.length > 0) {
      let filterData = data.filter((postDetail) => {
        if (
          postDetail.tags?.length > 0 &&
          userTags.includes(postDetail.tags[0])
        ) {
          return data;
        }
      });
      console.log(filterData);
      return filterData;
    }
  }
  return data;
}
